import React from 'react';

interface Props {
  currentStep: number;
  totalSteps: number;
}

export default function WizardProgressBar({ currentStep, totalSteps }: Props) {
  const pct = Math.round(((currentStep - 1) / (totalSteps - 1)) * 100);
  return (
    <div className="h-1 bg-gray-100 w-full">
      <div
        className="h-full bg-gradient-to-r from-blue-600 to-sky-400 transition-all duration-500 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}